import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=10b81f30&scoped=true&"
import script from "./AddressSelect.vue?vue&type=script&async=true&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=10b81f30&lang=scss&scoped=true&"
import style1 from "./AddressSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b81f30",
  null
  
)

export default component.exports